





















import { Component, Mixins, Prop } from "vue-property-decorator";
import { Color, LineKinds, LineStyle } from "../../domain/drawing";
import { ModelEditableMixin } from "../system/mixins";
import ColorPicker from "./ColorPicker.vue";
import LineKindDropDownSelector from "./LineKindDropDownSelector.vue";
import LineWidthDropDownSelector from "./LineWidthDropDownSelector.vue";

@Component({
  components: {
    colorPicker: ColorPicker,
    kindSelector: LineKindDropDownSelector,
    widthSelector: LineWidthDropDownSelector,
  },
})
export default class LineStyleEditor extends Mixins(ModelEditableMixin) {
  editingSource: LineStyle;

  @Prop()
  pallet: Color[];

  @Prop({ default: false })
  isFigure: boolean;

  @Prop({ default: false })
  isArrow: boolean;

  get color(): Color {
    return this.editingSource
      ? this.editingSource.color
      : undefined;
  }

  set color(value: Color) {
    this.writeProperty(s => s.color = value);
  }

  get kind(): LineKinds {
    return this.editingSource
      ? this.editingSource.kind
      : undefined;
  }

  set kind(value: LineKinds) {
    this.writeProperty(s => s.kind = value);
  }

  get width(): number {
    return this.editingSource
      ? this.editingSource.width
      : undefined;
  }

  set width(value: number) {
    this.writeProperty(s => s.width = value);
  }

  get defaultColor(): Color {
    return new Color("#000000");
  }
}
